/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_3_DescInputs */

const en_mk_publish_3_desc = /** @type {(inputs: Mk_Publish_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore a previous version, pause or wake your app, and download the project as a ZIP.`)
};

const id_mk_publish_3_desc = /** @type {(inputs: Mk_Publish_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke versi sebelumnya, jeda atau aktifkan aplikasi, dan unduh proyek sebagai ZIP.`)
};

/**
* | output |
* | --- |
* | "Restore a previous version, pause or wake your app, and download the project as a ZIP." |
*
* @param {Mk_Publish_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_3_desc = /** @type {((inputs?: Mk_Publish_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_3_desc(inputs)
	return en_mk_publish_3_desc(inputs)
});